const Array_Methods_Pratice_1 = () => {
  return (
    <div>
      <h1>Array Methods Pratice 1</h1>
    </div>
  );
};
export default Array_Methods_Pratice_1;
